export default __webpack_public_path__ + "static/media/lorenzProjection1a.5d43612a.svg";